import React, { useEffect, useState } from 'react';
import { makeStyles, Box } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { TransferServiceImpl } from '../../../../../fundTransfer/src/domain/Transfer/usecases';
import { InAPP2FAStep } from '../../../../../content-composer/src/components/ClientSideWizard/Steps/InApp2FAStep';
import { InitiateTransferResponseBody } from '../../../../../fundTransfer/src/domain/Transfer/entities/InitiateTransferResponseDTO';
import { ConsolidatedTransactionDetails } from '../../../domain/Transaction/entities/ConsolidatedTransaction';
import { ErrorContent } from '../../../../../content-composer/src/components/Partials/ErrorContent';
import {
  useWizardStepData,
  useWizardGoToNextStep,
} from '../../../../../content-composer/src/contexts/ClientSideWizard/hooks';
import { ECOMMBXLoader } from '../../../../../content-composer/src/components/Generic/ECOMMBXLoader/ECOMMBXLoader';

const useStyles = makeStyles(theme => ({
  errorContainer: {
    wordBreak: 'break-all',
  },
}));

const InitiateRequestDealerInApp2FA = () => {
  const [timestamp] = useState(new Date().toISOString());
  const { t } = useTranslation();
  // data from hooks
  const goToNextWizardStep = useWizardGoToNextStep();
  const stepData = useWizardStepData('initiateAuth') as { values: GenericObject };
  const { globalOrderId, transactionId } = stepData.values.transactionDetails as ConsolidatedTransactionDetails;

  const {
    data: initiateRequestDealerTransferData,
    error: initiateRequestDealerTransferError,
    isLoading: isLoadingInitiateRequestDealerTransfer,
  } = useInvokeSWRService<InitiateTransferResponseBody>(
    (stepData.values.fundTransfersService as TransferServiceImpl).InitiateRequestDealerTransfer,
    {
      orderCode: globalOrderId,
      appTransactionId: transactionId,
      meta: {
        timestamp,
      },
    },
    true,
    'transferService.InitiateRequestDealerTransfer',
  );

  const classes = useStyles();

  useEffect(() => {
    if (initiateRequestDealerTransferData && initiateRequestDealerTransferData?.authenticationMethod === null) {
      goToNextWizardStep({ ...stepData.values, initiateRequestDealerTransferData });
    }
  }, [initiateRequestDealerTransferData, goToNextWizardStep, stepData.values]);

  if (isLoadingInitiateRequestDealerTransfer) {
    return <ECOMMBXLoader size='small' />;
  }

  if (initiateRequestDealerTransferError) {
    return (
      <Box width='100%' className={classes.errorContainer}>
        <ErrorContent
          code={initiateRequestDealerTransferError.code}
          message={t('transactionDetails.AcceptFinalize.Huston.Message')}
          subtitle={t('transactionDetails.AcceptFinalize.DealerRateInitialize.Error.Message')}
          onClickBtn={stepData.values.onBackHome}
          isFullwidth={true}
        />
      </Box>
    );
  }

  return (
    <InAPP2FAStep
      stepId='initiateAuth'
      authenticationMethod={initiateRequestDealerTransferData?.authenticationMethod}
      resetFlow={stepData.values.onCancel}
      externalAuthorizationId={initiateRequestDealerTransferData?.authorizationId}
      title={t('FundsTransfersPage.TransferOtp.title')}
      shouldEnableOtpTitle={false}
      shouldForceMobileOtpView={true}
      onToggleDrawer={stepData.values.onCancel}
      externalOnGoToNextWizardStep={() => goToNextWizardStep({ ...stepData.values, initiateRequestDealerTransferData })}
    />
  );
};

export { InitiateRequestDealerInApp2FA };
